import type { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppLayout } from './components/Layout/AppLayout';
import { ProtectedRoute, GuestRoute, AdminRoute } from './app/ProtectedRoute';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { HomePage } from './pages/HomePage/HomePage';
import { ProjectsPage } from './pages/ProjectsPage/ProjectsPage';
import { ProjectCardPage } from './pages/ProjectCardPage/ProjectCardPage';
import { SupportPage } from './pages/SupportPage/SupportPage';
import { NewsPage } from './pages/NewsPage/NewsPage';
import { SupportAnswersPage } from './pages/SupportAnswersPage/SupportAnswersPage';
import { SupportAnswerDetailPage } from './pages/SupportAnswerDetailPage/SupportAnswerDetailPage';
import { AccessPage } from './pages/AccessPage/AccessPage';
import { SizesPage } from './pages/SizesPage/SizesPage';
import { NewsHandbookPage } from './pages/NewsHandbookPage/NewsHandbookPage';
import { SupportRequestsPage } from './pages/SupportRequestsPage/SupportRequestsPage';
import { RequestsPage } from './pages/RequestsPage/RequestsPage';
import { StoragePage } from './pages/StoragePage/StoragePage';
import { BlocksPage } from './pages/BlocksPage/BlocksPage';
import { FaqPage } from './pages/FaqPage/FaqPage';
import { NotificationsPage } from './pages/NotificationsPage/NotificationsPage';
import { ReportsPage } from './pages/ReportsPage/ReportsPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage/ResetPasswordPage';
import { NewPasswordPage } from './pages/NewPasswordPage/NewPasswordPage';
import { PasswordChangedPage } from './pages/PasswordChangedPage/PasswordChangedPage';
import { UserNotificationsPage } from './pages/UserNotificationsPage/UserNotificationsPage';
import { NewsDetailPage } from './pages/NewsDetailPage/NewsDetailPage';
import { ProductAnalogsPage } from './pages/ProductAnalogsPage/ProductAnalogsPage';

export const App: FC = () => (
  <Routes>
    <Route element={<GuestRoute />}>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/reset-password/:token" element={<NewPasswordPage />} />
      <Route path="/password-changed" element={<PasswordChangedPage />} />
    </Route>

    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectCardPage />} />
        <Route
          path="/projects/:projectId/results"
          element={<Navigate to=".." relative="path" replace />}
        />

        {/* Техподдержка: /support общий для всех ролей — у админа ведёт сюда же из подраздела */}
        <Route path="/support" element={<SupportPage />} />
        <Route path="/support-answers" element={<SupportAnswersPage />} />
        <Route path="/support-answers/:id" element={<SupportAnswerDetailPage />} />

        {/* /news в меню скрыт, но на него ведёт «Все новости» с главной */}
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />

        <Route path="/faq" element={<FaqPage />} />
        <Route path="/user/notifications" element={<UserNotificationsPage />} />

        {/* для админов и суперадминов */}
        <Route element={<AdminRoute />}>
          <Route path="/access" element={<AccessPage />} />

          {/* Техническая поддержка */}
          <Route path="/support-requests" element={<SupportRequestsPage />} />
          <Route path="/requests" element={<RequestsPage />} />

          {/* Справочники */}
          <Route
            path="/handbook/sizes"
            element={<Navigate to="/handbook/sizes/standard_size" replace />}
          />
          <Route path="/handbook/sizes/:tab" element={<SizesPage />} />
          <Route path="/handbook/news" element={<NewsHandbookPage />} />
          <Route path="/handbook/products" element={<ProductAnalogsPage />} />

          <Route path="/storage" element={<StoragePage />} />
          <Route path="/global-blocks" element={<BlocksPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Route>
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;